<div class="container" style="left: 0px">
    <div class="row" style="padding-top: 130px"></div>
    <div class="container" style="left: 0px; padding: 0px">
      <app-breadcrumb [category]="category"></app-breadcrumb>
    </div>
    <div class="row" style="padding-top: 2%">
      <div class="col-lg-2 col-sm-3">
        <section class="collection" id="collection" style="margin-bottom: 24px">
          <div
            class="accordion"
            id="accordionExample"
            style="border-right: solid 1px rgba(0, 0, 0, 0.137)"
          >
            <h5
              style="
                font-family: 'proxima-nova';
                font-size: 14px;
                font-weight: bold;
              "
            >
              I’m looking for
            </h5>
            <div class="card">
              <div class="card-header" id="headingOne">
                <button
                  class="btn-block dropdown-toggle2 text-left"
                  data-toggle="collapse"
                  data-target="#collapseOne"
                  aria-expanded="false"
                  aria-controls="collapseOne"
                >
                  Sleeve
                </button>
              </div>
  
              <div
                id="collapseOne"
                class="collapse"
                aria-labelledby="headingOne"
                data-parent="#accordionExample"
              >
                <div class="card-body" style="padding-left: 0px">
                  <form>
                    <div class="form-check" style="padding-left: 0px">
                      <div *ngFor="let s of offers" class="mk2">
                        <input
                          (change)="addColor($event.target!!.value)"
                          class="form-check-input"
                          style="color: black"
                          type="checkbox"
                          value="{{ s }}"
                          id="{{ s }}"
                        />
                        <label class="form-check-label" for="{{ s }}">
                          {{ s }} </label
                        ><br />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
  
            <div class="card">
              <div class="card-header" id="headingTwo">
                <button
                  class="btn-block dropdown-toggle2 text-left"
                  data-toggle="collapse"
                  data-target="#collapseTwo"
                  aria-expanded="false"
                  aria-controls="collapseTwo"
                >
                  Colour
                </button>
              </div>
              <div
                id="collapseTwo"
                class="collapse"
                aria-labelledby="headingTwo"
                data-parent="#accordionExample"
              >
                <div class="card-body" style="padding-left: 0px">
                  <form>
                    <div class="form-check" style="padding-left: 0px">
                      <div *ngFor="let s of colors" class="mk2">
                        <input
                          (change)="addColor(s)"
                          class="form-check-input"
                          style="color: black"
                          ng-checked="sc.includes(s)"
                          type="checkbox"
                          id="{{ s }}"
                        />
                        <label class="form-check-label" for="{{ s }}">
                          {{ s }} </label
                        ><br />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div>
              <span
                *ngFor="let s of sc"
                (click)="addColor(s)"
                style="
                  font-size: 12px;
                  margin-right: 12px;
                  color: rgba(0, 0, 0, 0.664);
                "
                class="form-check-label"
                for="{{ s }}"
              >
                {{ s }}
                <span
                  class="iconify"
                  style="color: rgba(0, 0, 0, 0.37)"
                  data-icon="ic:baseline-close"
                  data-inline="false"
                ></span
              ><br></span>
            </div>
            <div class="card">
              <div class="card-header" id="headingThree">
                <button
                  class="btn-block dropdown-toggle2 text-left"
                  data-toggle="collapse"
                  data-target="#collapseThree"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                >
                  Size
                </button>
              </div>
              <div
                id="collapseThree"
                class="collapse"
                aria-labelledby="headingThree"
                data-parent="#accordionExample"
              >
                <div class="card-body" style="padding-left: 0px">
                  <form>
                    <div class="form-check" style="padding-left: 0px">
                      <div *ngFor="let s of sizes" class="mk2">
                        <input
                          (change)="addSize(s)"
                          class="form-check-input"
                          type="checkbox"
                          ng-checked="ss.includes(s)"
                          id="{{ s }}"
                        />
                        <label class="form-check-label" for="{{ s }}">
                          {{ s }} </label
                        ><br />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div>
              <span
                *ngFor="let s of ss"
                (click)="addSize(s)"
                style="
                  font-size: 12px;
                  margin-right: 12px;
                  color: rgba(0, 0, 0, 0.664);
                "
                class="form-check-label"
                for="{{ s }}"
              >
                {{ s }}
                <span
                  class="iconify"
                  style="color: rgba(0, 0, 0, 0.37)"
                  data-icon="ic:baseline-close"
                  data-inline="false"
                ></span
              ></span>
            </div>
            <div class="card">
              <div class="card-header" id="headingTwo">
                <button
                  class="btn-block dropdown-toggle2 text-left"
                  data-toggle="collapse"
                  data-target="#collapsefour"
                  aria-expanded="false"
                  aria-controls="collapseTwo"
                >
                  Offers
                </button>
              </div>
              <div
                id="collapsefour"
                class="collapse"
                aria-labelledby="headingTwo"
                data-parent="#accordionExample"
              >
                <div class="card-body" style="padding-left: 0px">
                  <form>
                    <div class="form-check" style="padding-left: 0px">
                      <div *ngFor="let s of offers" class="mk2">
                        <input
                          (change)="addOffer($event.target!!.value)"
                          class="form-check-input"
                          style="color: black"
                          type="checkbox"
                          ng-checked="so.includes(s)"
                          value="{{ s }}"
                          id="{{ s.replaceAll(' ', '') }}"
                        />
                        <label
                          class="form-check-label"
                          for="{{ s.replaceAll(' ', '') }}"
                        >
                          {{ s }} </label
                        ><br />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
  
            <div>
              <span
                *ngFor="let s of so"
                (click)="addOffer(s)"
                style="
                  font-size: 12px;
                  margin-right: 12px;
                  color: rgba(0, 0, 0, 0.664);
                "
                class="form-check-label"
                for="{{ s }}"
              >
                {{ s }}
                <span
                  class="iconify"
                  style="color: rgba(0, 0, 0, 0.37)"
                  data-icon="ic:baseline-close"
                  data-inline="false"
                ></span
              ><br></span>
            </div>
          </div>
        </section>
      </div>
      <div class="col-lg-10 col-sm-9">
        <div class="product">
          <b>{{ title }}</b>
          <button
            class="btn btn-c"
            style="float: right"
          >
            MOST RECOMMENDED<i class="bx bx-down-arrow-alt"></i>
          </button>
        </div>
        <!-- <br /> -->
        <div class="container" style="padding-top: 5%">
          <!-- <mat-grid-list cols="3">
              <mat-grid-tile  *ngFor="let product of products">
                <app-productitem [data]="product" ></app-productitem>
              </mat-grid-tile>
          </mat-grid-list> -->
          <div class="row">
            <div
              class="col-sm-6 col-lg-3"
              id="product"
              *ngFor="let product of products"
            >
              <app-productitem [data]="product"></app-productitem>
            </div>
          </div>
        </div>
  
        <br /><br />
        <div
          style="
            border-bottom: 1px solid rgba(0, 0, 0, 0.5);
            padding-bottom: 17px;
            width: fit-content;
            padding-left: 4px;
            padding-right: 16px;
          "
        >
        </div>
      </div>
    </div>
  </div>
  